module.exports = {
  methods: {
    validate: function (validation, value) {
      var object = {};
      object[validation] = value;
      var constraints = {};
      constraints[validation] = this.global_constraints[validation];
      return validate(object, constraints);
    }
  },
  data: function () {
    return {
      common_required_message: "^This field is mandatory",
      global_constraints: null
    }
  },
  mounted: function () {
    this.global_constraints = {
      required: {
        presence: {
          allowEmpty: false,
          message: this.common_required_message
        }
      },
      email: {
        presence: {
          allowEmpty: false,
          message: this.common_required_message
        },
        email: {
          message: "^The content is not a valid email"
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/jquery_validator_mixin.js